import {useSnapshot} from "valtio";
import image from "../../../assets/horizontal.png"
import {configuratorState, state} from "../../../state";
const Button = (props) => {
    const {activeWall, wallConfigStates,} = useSnapshot(configuratorState);
    const {usecase,dimension} = useSnapshot(state);
    const handleClick = () => {
        props.onClick?props.onClick():null;
    }
    return(
        <button onClick={handleClick} id={props.id} style={{marginLeft:`${props.rightAlign?"auto":""}`, visibility: props.visibility ? props.visibility : 'visible'}}className={`${props.image?"image-button":props.primary?"configurator-button-primary":"configurator-button-secondary"} 
                             ${!props.variableSize?props.image?"":props.confirm?"confirm-button":props.large?"configurator-button-large horizontal-options":"configurator-button-small":"variable-size"}
                             ${props.leftAlign?"options-left":""}
                             ${wallConfigStates[activeWall].structure===props.value?"selected":""}
                             ${wallConfigStates[activeWall].door===props.value?"selected":""}
                             ${wallConfigStates[activeWall].security===props.label?"selected":""}
                             ${wallConfigStates[activeWall].security===props.label?"selected":""}
                             ${props.halfParentWidth?props.leftPadding?"half-parent-width left-margin":"half-parent-width right-margin":""}
                             ${props.light?props.isSelected?"":"light-option":""}
                             ${props.selected?"selected":""}

                             `}><>
                             {props.children}
            {props.image?<img src={require(`../../../assets/${props.label}.png`)}/>:props.label}
                             </>
        </button>
    )
}

export default Button;